export default __webpack_public_path__ + "static/media/cook2.8ee1fbfb.png";